/**
 * Created by tigran on 19.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const ReportingIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      width={width}
      height={height}
      viewBox="-4 -4 40 40"
    >
      <path
        d="M3,14a1,1,0,0,0,.707-.293L12,5.414l7.293,7.293a1,1,0,0,0,1.414,0l9-9a1,1,0,1,0-1.414-1.414L20,10.586,12.707,3.293a1,1,0,0,0-1.414,0l-9,9A1,1,0,0,0,3,14Z"
        fill={color}
        data-color="color-2"
      />
      <rect x="18" y="21" width="4" height="9" rx="0.5" fill={color} />
      <rect x="26" y="12" width="4" height="18" rx="0.5" fill={color} />
      <rect x="10" y="12" width="4" height="18" rx="0.5" fill={color} />
      <rect x="2" y="21" width="4" height="9" rx="0.5" fill={color} />
    </svg>
  );
};
